
const getPendingChallengesOrChallengeVerification =  {}
const getChallengeVerificationFromChallengeAnswers = {}
const getChallengeVerification = {}
const getSubplebbitChallengeFromSubplebbitChallengeSettings = {}
const plebbitJsChallenges = {}
export {
  plebbitJsChallenges,
  getPendingChallengesOrChallengeVerification,
  getChallengeVerificationFromChallengeAnswers,
  getChallengeVerification,
  getSubplebbitChallengeFromSubplebbitChallengeSettings
}
